import { Grid, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TextInput } from '@components';
import { TransitViewStakeholdersFormValues } from './validateTransitViewStakeholdersForm';

interface CarrierSectionProps {
  form: UseFormReturnType<TransitViewStakeholdersFormValues>;
  editDisabled: boolean;
}

export const CarrierSection: React.FC<CarrierSectionProps> = ({ form, editDisabled }) => {
  return (
    <Stack mb="xl">
      <Title order={5} fw={600}>
        Carrier
      </Title>

      <Grid>
        <Grid.Col span={3}>
          <TextInput {...form.getInputProps('Consignment.Carrier.identificationNumber')} label="Identification number" disabled={editDisabled} />
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col span={3}>
          <TextInput {...form.getInputProps('Consignment.Carrier.ContactPerson.name')} label="Contact Name" disabled={editDisabled} />
        </Grid.Col>
        <Grid.Col span={3}>
          <TextInput {...form.getInputProps('Consignment.Carrier.ContactPerson.phoneNumber')} label="Phone Number" disabled={editDisabled} />
        </Grid.Col>
        <Grid.Col span={3}>
          <TextInput {...form.getInputProps('Consignment.Carrier.ContactPerson.eMailAddress')} label="eMail Address" disabled={editDisabled} />
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
